import { DEFAULT_TENANT } from './tenants'

export const DEFAULT_SIDEBAR_LOGO_URL = 'https://iebtinovacao.com.br/'

const TENANT_SHORT_NAMES: Record<string, string> = {
  'white-label': 'Zing',
  'zing': 'Zing',
  'zing-teia': 'Teia',
  'zing-itabirito': 'Hub Itabirito',
  'zing-cdl': 'Horizonte',
  'zing-guaxupe': 'Guaxupé',
}

const ACTIVE_TENANT = (import.meta.env.VITE_TENANT as string) ?? DEFAULT_TENANT

export const TENANT_SHORT_NAME = TENANT_SHORT_NAMES[ACTIVE_TENANT] ?? 'Zing'
export const TENANT_LEGAL_NAME = 'IEBT Innovation'
export const TENANT_CNPJ = '11.053.814/0001-00'
export const TENANT_ADDRESS = 'Rua Professor José Vieira de Mendonça, nº 770, sala 408 - Engenho Nogueira, Belo Horizonte/MG'
export const TENANT_JURISDICTION = 'Belo Horizonte/MG'
export const TENANT_LEGAL_SHORT_NAME = 'IEBT'
export const TENANT_INSTITUTIONAL_URL = 'https://www.iebtinnovation.com'
export const TENANT_CONTACT_EMAIL = 'zing@zinginnovation.com'
export const TENANT_SOCIAL_FACEBOOK_URL = 'https://www.facebook.com/iebtgestaoeinovacao/'
export const TENANT_SOCIAL_INSTAGRAM_URL = 'https://www.instagram.com/iebtinnovation/'
export const TENANT_SOCIAL_LINKEDIN_URL = 'https://www.linkedin.com/company/iebt/'
